export enum LengthUnits {
  MILLIMETER = 'mm',
  CENTIMETER = 'cm',
  METER = 'm',
  KILOMETER = 'km',
  INCH = 'in',
  FOOT = 'ft',
  YARD = 'yd',
  MILE = 'mi',
}

export enum WeightUnits {
  GRAM = 'g',
  KILOGRAM = 'kg',
  TON = 't',
  OUNCE = 'oz',
  POUND = 'lb',
}
